import { FieldContext, ValidationResult } from "@angular/forms/signals";
import { IDateRange } from "@front/m19-ui";

export function isCompleteDateRange(range: IDateRange | null | undefined): boolean {
  return !!range?.start && !!range.end;
}

export function validateCompleteDateRange(context: FieldContext<IDateRange | null>): ValidationResult {
  return isCompleteDateRange(context.value())
    ? null
    : { kind: "incompleteDateRange", message: "common.select_start_and_end_date" };
}
